var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { CharacterCounterComponent, ReactElementFactory } from "survey-react-ui";
import { StringEditorViewModelBase, editableStringRendererName } from "survey-creator-core";
import { CreatorModelElement } from "./ModelElement";
var SurveyLocStringEditor = /** @class */ (function (_super) {
    __extends(SurveyLocStringEditor, _super);
    function SurveyLocStringEditor(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.onChangedHandler = function (sender, options) {
            _this.setState({ changed: !!_this.state && _this.state.changed ? _this.state.changed + 1 : 1 });
        };
        _this.onBlur = function (event) {
            if (_this.svStringEditorRef.current) {
                _this.svStringEditorRef.current.spellcheck = false;
            }
            _this.locString["__isEditing"] = false;
            _this.justFocused = false;
            _this.baseModel.onBlur(event.nativeEvent);
            return _this.baseModel.errorText;
        };
        _this.onCompositionStart = function (event) {
            _this.baseModel.onCompositionStart(event.nativeEvent);
        };
        _this.onCompositionEnd = function (event) {
            _this.baseModel.onCompositionEnd(event.nativeEvent);
        };
        _this.onInput = function (event) {
            _this.baseModel.onInput(event.nativeEvent);
        };
        _this.onPaste = function (event) {
            _this.baseModel.onPaste(event.nativeEvent);
        };
        _this.justFocused = false;
        _this.onFocus = function (event) {
            _this.baseModel.onFocus(event.nativeEvent);
            _this.justFocused = true;
        };
        _this.onKeyDown = function (event) {
            return _this.baseModel.onKeyDown(event.nativeEvent);
        };
        _this.onKeyUp = function (event) {
            return _this.baseModel.onKeyUp(event.nativeEvent);
        };
        _this.onMouseUp = function (event) {
            return _this.baseModel.onMouseUp(event.nativeEvent);
        };
        _this.done = function (event) {
            _this.baseModel.done(event);
            _this.locString["__isEditing"] = false;
        };
        _this.edit = function (event) {
            _this.svStringEditorRef.current.focus();
            // document.execCommand('selectAll', false, null);
            _this.locString["__isEditing"] = true;
            _this.baseModel.onClick(event);
        };
        _this.htmlValue = {
            __html: (_a = _this.locString) === null || _a === void 0 ? void 0 : _a.renderedHtml
        };
        _this.state = { changed: 0 };
        _this.svStringEditorRef = React.createRef();
        return _this;
    }
    SurveyLocStringEditor.prototype.createModel = function (props) {
        if (this.baseModel) {
            this.baseModel.dispose();
        }
        this.baseModel = new StringEditorViewModelBase(this.locString, this.creator);
    };
    SurveyLocStringEditor.prototype.getUpdatedModelProps = function () {
        return ["creator", "locString"];
    };
    Object.defineProperty(SurveyLocStringEditor.prototype, "locString", {
        get: function () {
            return this.props.locStr.locStr;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLocStringEditor.prototype, "creator", {
        get: function () {
            return this.props.locStr.creator;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLocStringEditor.prototype, "style", {
        get: function () {
            return this.props.style;
        },
        enumerable: false,
        configurable: true
    });
    SurveyLocStringEditor.prototype.getStateElement = function () {
        return this.baseModel;
    };
    Object.defineProperty(SurveyLocStringEditor.prototype, "errorText", {
        get: function () {
            return this.baseModel.errorText;
        },
        enumerable: false,
        configurable: true
    });
    SurveyLocStringEditor.prototype.componentDidMount = function () {
        var _this = this;
        _super.prototype.componentDidMount.call(this);
        if (!this.locString)
            return;
        this.baseModel.setLocString(this.locString);
        this.baseModel.getEditorElement = function () { return _this.svStringEditorRef.current; };
        this.baseModel.blurEditor = function () {
            _this.svStringEditorRef.current.blur();
            _this.svStringEditorRef.current.spellcheck = false;
        };
        this.baseModel.afterRender();
        this.locString.onStringChanged.add(this.onChangedHandler);
        if (this.locString["__isEditing"]) {
            this.svStringEditorRef.current.focus();
            // document.execCommand('selectAll', false, null);
        }
    };
    SurveyLocStringEditor.prototype.componentDidUpdate = function (prevProps, prevState) {
        _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
        this.baseModel.setLocString(this.locString);
        this.baseModel.afterRender();
    };
    SurveyLocStringEditor.prototype.componentWillUnmount = function () {
        _super.prototype.componentWillUnmount.call(this);
        this.baseModel.detachFromUI();
        if (!this.locString)
            return;
        this.locString.onStringChanged.remove(this.onChangedHandler);
    };
    Object.defineProperty(SurveyLocStringEditor.prototype, "placeholder", {
        get: function () {
            return this.baseModel.placeholder;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLocStringEditor.prototype, "contentEditable", {
        get: function () {
            return this.baseModel.contentEditable;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLocStringEditor.prototype, "className", {
        get: function () {
            return this.baseModel.className(this.locString.renderedHtml);
        },
        enumerable: false,
        configurable: true
    });
    SurveyLocStringEditor.prototype.render = function () {
        if (!this.locString) {
            return null;
        }
        var control = null;
        if (this.locString.hasHtml) {
            if (this.htmlValue.__html !== this.locString.renderedHtml) {
                this.htmlValue = { __html: this.locString.renderedHtml };
            }
            control = (React.createElement("span", { role: "textbox", ref: this.svStringEditorRef, className: "sv-string-editor sv-string-editor--html", contentEditable: this.contentEditable, spellCheck: false, "aria-placeholder": this.placeholder, "aria-label": this.placeholder || "content editable", suppressContentEditableWarning: true, 
                // style={this.style}
                dangerouslySetInnerHTML: this.htmlValue, onBlur: this.onBlur, onFocus: this.onFocus, onKeyDown: this.onKeyDown, onMouseUp: this.onMouseUp, onClick: this.edit }));
        }
        else {
            control = (React.createElement("span", { role: "textbox", ref: this.svStringEditorRef, className: "sv-string-editor", contentEditable: this.contentEditable, spellCheck: false, "aria-placeholder": this.placeholder, "aria-label": this.placeholder || "content editable", suppressContentEditableWarning: true, 
                // style={this.style}
                key: this.locString.renderedHtml, onBlur: this.onBlur, onInput: this.onInput, onPaste: this.onPaste, onCompositionStart: this.onCompositionStart, onCompositionEnd: this.onCompositionEnd, onFocus: this.onFocus, onKeyDown: this.onKeyDown, onKeyUp: this.onKeyUp, onMouseUp: this.onMouseUp, onClick: this.edit }, this.locString.renderedHtml));
        }
        var counter = this.baseModel.showCharacterCounter ? (React.createElement(CharacterCounterComponent, { counter: this.baseModel.characterCounter, remainingCharacterCounter: this.baseModel.getCharacterCounterClass })) : null;
        return (React.createElement("span", { className: this.className },
            React.createElement("span", { className: "svc-string-editor__content" },
                React.createElement("div", { className: "svc-string-editor__border svc-string-editor__border--hover", onClick: this.edit }),
                React.createElement("div", { className: "svc-string-editor__border svc-string-editor__border--focus", onClick: this.edit }),
                React.createElement("span", { className: "svc-string-editor__input" },
                    control,
                    React.createElement("div", { className: "svc-string-editor__controls", onClick: this.edit }),
                    counter)),
            this.errorText ? React.createElement("span", { className: "svc-string-editor__error" }, this.errorText) : ""));
    };
    return SurveyLocStringEditor;
}(CreatorModelElement));
export { SurveyLocStringEditor };
ReactElementFactory.Instance.registerElement(editableStringRendererName, function (props) {
    return React.createElement(SurveyLocStringEditor, props);
});
